import { UploaderProviderLocalState } from "../../types";
import { UploadAction, UploadActionKind } from "./upload-actions";

export const defaultUploadProviderStateReducer: UploaderProviderLocalState = {
    changes: {
        columnsToCreate: [],
        columnsToUpdate: [],
        columnsHeadersMap: new Map<string, string>(),
        doorsForDisableOrEnable: [],
        doorsForDisableOrEnableWithUnits: [],
    },
    errors: {
        messages: undefined,
    },
    feedbackUpload: {
        isUploading: false,
        wasProcessed: false,
    },
    feedbackUpdatingData: {
        isUpdating: false,
        wasUpdated: false,
    },
};

export function uploadReducer(state: UploaderProviderLocalState, action: UploadAction) {
    const { type, payload } = action;
    switch (type) {
        case UploadActionKind.SetColumnHeaders:
            return {
                ...state,
                changes: {
                    ...state.changes,
                    columnsHeadersMap: payload,
                },
            };
        case UploadActionKind.AddColumnsToCreate:
            return {
                ...state,
                changes: {
                    ...state.changes,
                    columnsToCreate: payload,
                },
            };
        case UploadActionKind.AddColumnsToUpdate:
            return {
                ...state,
                changes: {
                    ...state.changes,
                    columnsToUpdate: payload,
                },
            };
        case UploadActionKind.AddDoorsForEnableOrDisable:
            return {
                ...state,
                changes: {
                    ...state.changes,
                    doorsForDisableOrEnable: payload,
                },
            };
        case UploadActionKind.AddDoorsForEnableOrDisableWithUnits:
            return {
                ...state,
                changes: {
                    ...state.changes,
                    doorsForDisableOrEnableWithUnits: payload,
                },
            };

        case UploadActionKind.AddErrorMessages:
            return {
                ...state,
                errors: {
                    messages: payload,
                },
            };
        case UploadActionKind.ClearErrorMessages:
            return {
                ...state,
                errors: {
                    messages: undefined,
                },
            };

        case UploadActionKind.IsUploadingFile:
            return {
                ...state,
                feedbackUpload: {
                    ...state.feedbackUpload,
                    wasProcessed: false,
                    isUploading: true,
                },
            };
        case UploadActionKind.FileProcessed:
            return {
                ...state,
                feedbackUpload: {
                    ...state.feedbackUpload,
                    isUploading: false,
                    wasProcessed: true,
                },
            };

        case UploadActionKind.IsUpdatingData:
            return {
                ...state,
                feedbackUpdatingData: {
                    ...state.feedbackUpdatingData,
                    wasUpdated: false,
                    isUpdating: true,
                },
            };
        case UploadActionKind.DataUpdated:
            return {
                ...state,
                feedbackUpdatingData: {
                    ...state.feedbackUpdatingData,
                    wasUpdated: true,
                    isUpdating: false,
                },
            };

        case UploadActionKind.resetAllStates:
            return {
                ...state,
                changes: {
                    ...state.changes,
                    columnsToCreate: [],
                    columnsToUpdate: [],
                    columnsHeadersMap: new Map<string, string>(),
                    doorsForDisableOrEnable: [],
                    doorsForDisableOrEnableWithUnits: [],
                },
                errors: {
                    messages: undefined,
                },
                feedbackUpload: {
                    ...state.feedbackUpload,
                    isUploading: false,
                    wasProcessed: false,
                },
                feedbackUpdatingData: {
                    ...state.feedbackUpdatingData,
                    wasUpdated: false,
                    isUpdating: false,
                },
            };

        default:
            return state;
    }
}
